import { render, staticRenderFns } from "./GroupOwner.vue?vue&type=template&id=4c8545f0&"
import script from "./GroupOwner.vue?vue&type=script&lang=js&"
export * from "./GroupOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports